import { definePayloadPlugin, definePayloadReducer, definePayloadReviver } from '#imports'
import { getApiResponsePayloadReducer, getApiResponsePayloadReviver, createClassesMap } from '@composable-api-utils/serialization'
import { models } from './model-serialization'

export default definePayloadPlugin(() => {
    definePayloadReducer('response', getApiResponsePayloadReducer())
    definePayloadReviver('response', getApiResponsePayloadReviver(models))
})
